import { Component } from 'react';
import { get, flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import {
  MUTATION_UPDATE_VIEW,
  MUTATION_UPDATE_SORT_BY,
  MUTATION_UPDATE_SEARCH,
  MUTATION_RESET_SEARCH,
  QUERY_USER_CRITERIA
} from './gql';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

const updateToggle = (toggle) => {
  localStorage.setItem('user.toggle', toggle);
};

class UserContainer extends Component {
  constructor() {
    super();

    this.getSetting = this.getSetting.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.updatePagination = this.updatePagination.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.updateSortBy = this.updateSortBy.bind(this);
    this.updateView = this.updateView.bind(this);
  }

  getSetting(setting, fallback) {
    const { [setting]: existing } = this.props;

    const storage = localStorage.getItem(`user.${setting}`);

    return storage || existing || fallback;
  }

  resetSearch = () => {
    const { resetSearch } = this.props;

    return resetSearch();
  };

  updatePagination = (pagination) => {
    const existing = JSON.parse(this.getSetting('pagination', '{}'));

    localStorage.setItem('user.pagination', JSON.stringify({ ...existing, ...pagination }));
  };

  updateSearch = (search) => {
    const { updateSearch } = this.props;

    localStorage.setItem('user.search', search);

    return updateSearch({ variables: { search } });
  };

  updateSortBy = (sortBy) => {
    const { updateSortBy } = this.props;

    localStorage.setItem('user.sortBy', sortBy);

    return updateSortBy({ variables: { sortBy } });
  };

  updateView = (view) => {
    const { updateView } = this.props;
    return updateView({ variables: { view } });
  };

  buildProps = () => ({
    pagination: JSON.parse(this.getSetting('pagination', '{}')),
    search: this.getSetting('search'),
    sortBy: this.getSetting('sortBy'),
    toggle: this.getSetting('toggle'),
    view: this.getSetting('view'),
    resetSearch: this.resetSearch,
    updatePagination: this.updatePagination,
    updateSearch: this.updateSearch,
    updateSortBy: this.updateSortBy,
    updateToggle,
    updateView: this.updateView
  });

  render() {
    const { children, ...otherProps } = this.props;
    return children(this.buildProps(otherProps));
  }
}

UserContainer.propTypes = {
  children: ReactChildrenPropType.isRequired,
  resetSearch: PropTypes.func.isRequired,
  updateSearch: PropTypes.func.isRequired,
  updateSortBy: PropTypes.func.isRequired,
  updateView: PropTypes.func.isRequired,
  pagination: PropTypes.string,
  search: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  toggle: PropTypes.string,
  view: PropTypes.string.isRequired
};

UserContainer.defaultProps = {
  pagination: '{}',
  toggle: undefined
};

const UserContainerWithMutations = compose(
  graphql(MUTATION_UPDATE_VIEW, { name: 'updateView' }),
  graphql(MUTATION_UPDATE_SORT_BY, { name: 'updateSortBy' }),
  graphql(MUTATION_UPDATE_SEARCH, { name: 'updateSearch' }),
  graphql(MUTATION_RESET_SEARCH, { name: 'resetSearch' }),
  graphql(QUERY_USER_CRITERIA, {
    options: () => ({
      fetchPolicy: 'cache-first',
      ssr: false // Authentication only works client side
    }),
    props: ({ data: { userCriteria } }) => ({
      pagination: get(userCriteria, 'paginationSupplier', '{}'),
      search: get(userCriteria, 'searchSupplier', ''),
      sortBy: get(userCriteria, 'sortBySupplier', ''),
      toggle: get(userCriteria, 'toggleSupplier', ''),
      view: get(userCriteria, 'viewSupplier', '')
    })
  })
)(UserContainer);

export default UserContainerWithMutations;
